import { useTranslation } from 'react-i18next'
import { cn } from '@shared/lib'
import { useParticipantBalance } from '../api/participantPaymentApi'
import { CURRENCEIS } from '../model/types'

export function ParticipantBalanceChip() {
  const { t } = useTranslation('participant')
  const { data } = useParticipantBalance()

  if (!data) return null

  const symbol = CURRENCEIS[data.currency] ?? data.currency

  return (
    <span
      className={cn(
        'bg-orange-subtle gap-1 rounded-lg px-3 py-3',
        'inline-flex items-center',
        'text-orange text-sm font-bold whitespace-nowrap'
      )}
    >
      {t('dashboard.balance')} {data.balance.toLocaleString()} {symbol}
    </span>
  )
}
